import { render, staticRenderFns } from "./UserRecycleBinModal.vue?vue&type=template&id=08b620db&scoped=true"
import script from "./UserRecycleBinModal.vue?vue&type=script&lang=js"
export * from "./UserRecycleBinModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b620db",
  null
  
)

export default component.exports